require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-herald-sun-features-toorak-gardens-in-top-50-homes.json") })
        }
      }, "path---journal-herald-sun-features-toorak-gardens-in-top-50-homes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-herald-sun-features-toorak-gardens-in-top-50-homes!./.cache/json/journal-herald-sun-features-toorak-gardens-in-top-50-homes.json
// module id = 497
// module chunks = 231608221292675